<template>
    <CreateModelLayout
        :indexRoute="$route('admin::signatures.index')"
        :storeRoute="$route('admin::signatures.store')"
        :modelNameSingular="__('admin::signatures.signature')"
        :modelNamePlural="__('admin::signatures.signatures')"
        :form="form"
    >

        <FormGroup :label="__('admin::labels.name')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.priority')" :error="errors.priority">
            <Input name="priority" type="number" step="1" :has-error="exists(errors.priority)" v-model="form.priority" :required="true" />
        </FormGroup>

        <FormGroup class="mb-4">
            <Toggle v-model:checked="form.is_active" :label="__('admin::labels.is_active')" />
        </FormGroup>

        <Heading type="h2" class="mt-4">{{ __('admin::labels.criteria') }}</Heading>

        <Criteria
            :criteriumOptions="criteriumOptions"
            v-model="form.criteria"
        />

        <Heading type="h2" class="mt-4">{{ __('admin::labels.template') }}</Heading>

        <FormGroup :label="__('admin::labels.template')" :error="errors.template">
            <Select name="template" :options="selectableTemplateOptions" :has-error="exists(errors.template)" v-model="form.template" />
        </FormGroup>

        <Heading type="h2">{{ __('admin::labels.variables') }}</Heading>

        <FormGroup
            v-for="(variableName, variableKey) in templateVariables"
            :key="variableKey"
            :label="variableName"
        >
            <Input
                type="text"
                :modelValue="form.meta[variableKey] || ''"
                @update:modelValue="form.meta[variableKey] = $event"
            />
        </FormGroup>

    </CreateModelLayout>
</template>

<script>
    export default {
        props: {
            errors: Object,
            templateOptions: Object,
            criteriumOptions: Object,
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    is_active: false,
                    priority: 10,
                    criteria: [],
                    template: Object.keys(this.templateOptions)[0],
                    meta: {},
                })
            }
        },
        computed: {
            selectableTemplateOptions() {
                let options = {};

                for (let property in this.templateOptions) {
                    options[property] = this.templateOptions[property].name;
                }

                return options;
            },
            templateVariables() {
                return this.templateOptions[this.form.template].variables;
            },
        },
    }
</script>
